import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@api'

const markNotificationAsRead = async (notificationId: string): Promise<void> => {
  await api.patch<void>(`/notifications/${notificationId}/read`)
}

export const useMarkNotificationAsRead = () => {
  const queryClient = useQueryClient()

  return useMutation<void, Error, string>({
    mutationFn: markNotificationAsRead,
    onSuccess: () => {
      // `refetchType: 'all'` refetches every notification query, not just the
      // active tab. The list is split per tab (`['notifications', { tab }]`)
      // plus the menu unread-count query, all children of this root. With the
      // default ('active') only the visible tab refetched, so reading a
      // notification in "Tout" left the "Agenda"/"Demandes" tabs — and the menu
      // badge — showing a stale unread count until they were refetched.
      queryClient.invalidateQueries({
        queryKey: ['notifications'],
        refetchType: 'all',
      })
    },
  })
}

